import axios from "axios";

const { REACT_APP_SERVER_URL } = process.env;

export async function createAccount(dat) {
  const sendQuery = await axios.post(`${REACT_APP_SERVER_URL}/users`, dat);
  return sendQuery.data;
}

export async function loginUser(dat) {
  const sendQuery = await axios.post(
    `${REACT_APP_SERVER_URL}/users/login`,
    dat
  );
  return sendQuery.data;
}
